/*
 *
 * Copyright (c) 1999-2021 Luciad All Rights Reserved.
 *
 * Luciad grants you ("Licensee") a non-exclusive, royalty free, license to use,
 * modify and redistribute this software in source and binary code form,
 * provided that i) this copyright notice and license appear on all copies of
 * the software; and ii) Licensee does not utilize the software in a manner
 * which is disparaging to Luciad.
 *
 * This software is provided "AS IS," without a warranty of any kind. ALL
 * EXPRESS OR IMPLIED CONDITIONS, REPRESENTATIONS AND WARRANTIES, INCLUDING ANY
 * IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
 * NON-INFRINGEMENT, ARE HEREBY EXCLUDED. LUCIAD AND ITS LICENSORS SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING
 * OR DISTRIBUTING THE SOFTWARE OR ITS DERIVATIVES. IN NO EVENT WILL LUCIAD OR ITS
 * LICENSORS BE LIABLE FOR ANY LOST REVENUE, PROFIT OR DATA, OR FOR DIRECT,
 * INDIRECT, SPECIAL, CONSEQUENTIAL, INCIDENTAL OR PUNITIVE DAMAGES, HOWEVER
 * CAUSED AND REGARDLESS OF THE THEORY OF LIABILITY, ARISING OUT OF THE USE OF
 * OR INABILITY TO USE SOFTWARE, EVEN IF LUCIAD HAS BEEN ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGES.
 */
function parseQuery(str) {
  var qso = {};
  var qs = (str || document.location.search);
  // Check for an empty querystring
  if (qs == "") {
    return qso;
  }
  // Normalize the querystring
  qs = qs.replace(/(^\?)/, '').replace(/;/g, '&');
  while (qs.indexOf("&&") != -1) {
    qs = qs.replace(/&&/g, '&');
  }
  qs = qs.replace(/([\&]+$)/, '');
  // Break the querystring into parts
  qs = qs.split("&");
  // Build the querystring object
  for (var i = 0; i < qs.length; i++) {
    var qi = qs[i].split("=");
    qi = qi.map(function(n) {
      return decodeURIComponent(n)
    });
    if (typeof qi[1] === "undefined") {
      qi[1] = null;
    }
    if (typeof qso[qi[0]] !== "undefined") {
      // If a key already exists then make this an object
      if (typeof(qso[qi[0]]) == "string") {
        var temp = qso[qi[0]];
        if (qi[1] == "") {
          qi[1] = null;
        }
        qso[qi[0]] = [];
        qso[qi[0]].push(temp);
        qso[qi[0]].push(qi[1]);

      } else if (typeof(qso[qi[0]]) == "object") {
        if (qi[1] == "") {
          qi[1] = null;
        }
        qso[qi[0]].push(qi[1]);
      }
    } else {
      // If no key exists just set it as a string
      if (qi[1] == "") {
        qi[1] = null;
      }
      qso[qi[0]] = qi[1];
    }
  }
  return qso;
}

function getUrlQueryParameters(defaults) {
  defaults = defaults || {};
  var query = window.location.search;
  if (!query || query.length <= 1) {
    return defaults;
  }
  query = typeof queryParameters === "undefined" ? parseQuery(query) : JSON.parse(JSON.stringify(queryParameters));
  for (var attrname in defaults) {
    if (!query.hasOwnProperty(attrname)) {
      query[attrname] = defaults[attrname];
    }
  }
  return query;
}

function serializeQuery(obj, prefix) {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ? serializeQuery(v, k) : v === null ? encodeURIComponent(k) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}

function setUrlQueryParameters(obj) {
  var query = serializeQuery(obj);
  return query !== "" ? "?" + query : "";
}

var queryParameters = getUrlQueryParameters();

function determineBase() {
  if (window && window.location && window.location.origin) {
    return window.location.origin + "/";
  }
}

var URLUtil = {
  queryParameters: queryParameters,
  getUrlQueryParameters: getUrlQueryParameters,
  setUrlQueryParameters: setUrlQueryParameters,
  toUrl: toUrl,
  toSampleRoot: toSampleRoot,
  toResourceRoot: toResourceRoot,
  toDataRoot: toDataRoot,
  toSampleServices: toSampleServices,
  toSampleData: toSampleData,
  path: {}
};

Object.defineProperty(URLUtil.path, "BASE", {
  get: (function() {
    var cache = null;
    return function() {
      if (!cache) {
        cache = determineBase();
      }
      return cache;
    }
  })()
});

Object.defineProperty(URLUtil.path, "SAMPLES", {
  get: (function() {
    var cache = null;
    return function() {
      if (!cache) {
        cache = URLUtil.path.BASE + "samples/";
      }
      return cache;
    }
  })()
});

Object.defineProperty(URLUtil.path, "COMMON", {
  get: (function() {
    var cache = null;
    return function() {
      if (!cache) {
        cache = URLUtil.path.SAMPLES + "common/";
      }
      return cache;
    }
  })()
});

Object.defineProperty(URLUtil.path, "RESOURCES", {
  get: (function() {
    var cache = null;
    return function() {
      if (!cache) {
        cache = URLUtil.path.COMMON + "resources/";
      }
      return cache;
    }
  })()
});

Object.defineProperty(URLUtil.path, "DATA", {
  get: (function() {
    var cache = null;
    return function() {
      if (!cache) {
        cache = URLUtil.path.BASE + "sampledata/";
      }
      return cache;
    }
  })()
});

// This LuciadFusion server is for demonstration purposes only.
// You can use this server only for simple tests and demonstrations.
// You should not rely on this server in any way.
URLUtil.path.SAMPLESERVICES = "https://sampleservices.luciad.com/";
URLUtil.path.SAMPLEDATA = "https://sampledata.luciad.com/data/";

function toUrl(path) {
  if (path.startsWith("/")) {
    return URLUtil.path.BASE + path.slice(1);
  } else {
    let pathname = window.location.pathname;
    if (pathname.startsWith("/")) {
      pathname = pathname.slice(1);
    }

    if (pathname !== "" & !pathname.endsWith("/")) {
      pathname = pathname.split("/").slice(0, -1).concat("").join("/");
    }
    return URLUtil.path.BASE + pathname + path;
  }
}

function toSampleRoot(path) {
  return URLUtil.path.SAMPLES + path;
}

function toResourceRoot(path) {
  return URLUtil.path.RESOURCES + path;
}

function toDataRoot(path) {
  return URLUtil.path.DATA + path;
}

function toSampleServices(path) {
  return URLUtil.path.SAMPLESERVICES + path;
}

function toSampleData(path) {
  return URLUtil.path.SAMPLEDATA + path;
}

export {URLUtil};